import configData from '../../config.json';
import axios from 'axios';
import { Decrypt } from '../Helper';

export const GetIndustryType = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `lookups/get`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetIndustryTypeById = async (id) => {
    var config = {
        method: 'get',
        url: configData.API_ENDPOINT + `lookups/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        // data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const UpdateIndustryType = async (v, id) => {
    var config = {
        method: 'put',
        url: configData.API_ENDPOINT + `lookups/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
export const CreateIndustryType = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `lookups`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const DeleteIndustryType = async (id) => {
    var config = {
        method: 'delete',
        url: configData.API_ENDPOINT + `lookups/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        // data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetLookUps = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `lookups/get`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
export const GetSelectedBranches = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `lookups/getbranches`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}